import useQuery from "hooks/useQuery";
import { useEffect } from "react";
import { showErrorModal } from "utils";
import { getListaPrecio } from "../../api";

const useGetListaPrecio = (precioId) => {
  const { data, loading, refetch } = useQuery({
    autoFetch: false,
    queryFn: getListaPrecio,
    onError: (err) => showErrorModal({ err }),
  });

  const fetch = (precioId) => {
    refetch(precioId);
  }

  useEffect(() => {
    if (!precioId) return;
    fetch(precioId);
  }, [precioId]);

  return {
    tramos: data?.data?.lista_precios?.precios_distancias,
    articulos: data?.data?.lista_precios?.articulos,
    unidades: data?.data?.lista_precios?.unidades,
    loadingListaPrecio: loading,
    fetchListaPrecio: fetch,
  }
}

export default useGetListaPrecio;